/**
 * Wallet Pass Service
 * Issues and serves Apple Wallet and Google Wallet loyalty passes for Convercus programs. Internal administrators register programs, mint program API keys, maintain store locations, configure wallet design and levels, read adoption analytics and query the audit trail; customer-facing clients download a pass through the program-scoped download routes, and the wallets themselves keep it current through the Apple PassKit web service and the Google Wallet Objects callback. Every path below already carries the gateway base prefix `/wallet-pass-service`.
 *
 * The version of the OpenAPI document: 1.0.39938
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ScannablePlaceholderDto } from './scannable-placeholder-dto';
import { DesignAppleIdentityDto } from './design-apple-identity-dto';
import { WalletConfigInputDto } from './wallet-config-input-dto';


export interface DesignConfigResponseDto { 
    convercusProgramId: string;
    name: string;
    slug: string;
    exists: boolean;
    integration: DesignConfigResponseDto.IntegrationEnum | null;
    availableLevels: Array<string>;
    /**
     * Suggested placeholders for scannableCode.contentTemplate in this program.
     */
    scannablePlaceholders: Array<ScannablePlaceholderDto>;
    /**
     * Persisted wallet config
     */
    wallet: WalletConfigInputDto;
    apple: DesignAppleIdentityDto;
}
export namespace DesignConfigResponseDto {
    export type IntegrationEnum = 'toom' | 'gkr' | 'null';
    export const IntegrationEnum = {
        Toom: 'toom' as IntegrationEnum,
        Gkr: 'gkr' as IntegrationEnum,
        Null: 'null' as IntegrationEnum
    };
}


